export const getFileTypeByUrl = (url) => {
  if (!url) {
    return ''
  }

  const splitByParams = url.split('?')[0]

  const fileName = splitByParams.substring(splitByParams.lastIndexOf('/') + 1)

  return fileName.substring(fileName.lastIndexOf('.') + 1)
}

export const deepCopy = (data) => JSON.parse(JSON.stringify(data))

const isBrowserDownloadableUrl = (url) =>
  typeof url === 'string' &&
  (url.startsWith('http://') ||
    url.startsWith('https://') ||
    url.startsWith('/') ||
    url.startsWith('blob:'))

/**
 * Parse a data: URL into a Blob (for save-as download).
 */
export const dataUrlToBlob = (dataUrl) => {
  if (typeof dataUrl !== 'string' || !dataUrl.startsWith('data:')) {
    return null
  }
  const comma = dataUrl.indexOf(',')
  if (comma === -1) return null
  const header = dataUrl.slice(0, comma)
  const base64 = dataUrl.slice(comma + 1)
  const mimeMatch = header.match(/data:([^;,]+)/)
  const mime = mimeMatch ? mimeMatch[1] : 'application/octet-stream'
  const isBase64 = /;base64/i.test(header)
  let binary
  try {
    binary = isBase64 ? atob(base64) : decodeURIComponent(base64)
  } catch {
    return null
  }
  const len = binary.length
  const bytes = new Uint8Array(len)
  for (let i = 0; i < len; i += 1) {
    bytes[i] = binary.charCodeAt(i)
  }
  return new Blob([bytes], { type: mime })
}

export const downloadBlob = (blob, filename = 'download') => {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.rel = 'noopener'
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}

export const downloadFromDataUrl = (dataUrl, filename) => {
  const blob = dataUrlToBlob(dataUrl)
  if (!blob) return
  downloadBlob(blob, filename || 'download')
}

/**
 * Open a document URL in a new tab (e.g. clinician image with file_url).
 */
export const downloadFile = (file) => {
  const url = file?.file_url || file?.file
  if (!isBrowserDownloadableUrl(url)) return
  window.open(url, '_blank', 'noopener,noreferrer')
}
